import { supabase } from '../lib/supabase';

/**
 * Test login functionality
 * Usage: testLogin('test@example.com', 'password123')
 */
export const testLogin = async (email, password) => {
  console.log('🔐 Testing login functionality...\n');
  
  if (!email || !password) {
    console.error('❌ Please provide email and password');
    console.log('Usage: testLogin("your@email.com", "yourpassword")');
    return;
  }

  try {
    console.log('1. Attempting to sign in...');
    console.log('   Email:', email);
    
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });

    if (error) {
      console.log('❌ Login failed:', error.message);
      console.log('   Error code:', error.status);
      console.log('\nPossible issues:');
      console.log('  - Email not confirmed (check your inbox)');
      console.log('  - Wrong password');
      console.log('  - Account doesn\'t exist');
      return { success: false, error };
    }

    if (data?.session) {
      console.log('✅ Login successful!');
      console.log('   User ID:', data.user.id);
      console.log('   Email:', data.user.email);
      console.log('   Session active:', !!data.session);
      
      // Check if profile exists
      console.log('\n2. Checking user profile...');
      const { data: profile, error: profileError } = await supabase
        .from('user_profiles')
        .select('*')
        .eq('id', data.user.id)
        .single();

      if (profileError && profileError.code !== 'PGRST116') {
        console.log('⚠️ Profile error:', profileError.message);
      } else if (profile) {
        console.log('✅ Profile found');
        console.log('   Nickname:', profile.nickname);
      } else {
        console.log('⚠️ No profile found (user may not have completed signup)');
      }

      return { success: true, data };
    } else {
      console.log('⚠️ Login response received but no session');
      console.log('   This might mean email confirmation is required');
      return { success: false, error: 'No session created' };
    }
  } catch (err) {
    console.error('❌ Login test failed:', err);
    return { success: false, error: err };
  }
};

// Make it available globally
if (typeof window !== 'undefined') {
  window.testLogin = testLogin;
}


